import React, { useCallback, useMemo } from "react";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { AHSeparator, ListItem } from "arkh";
import { TeamScheduleAdminSelectTeamQuery } from "./__generated__/TeamScheduleAdminSelectTeamQuery.graphql";
import { TeamIconCircle } from "../../components/mobile/TeamIconCircle";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { FlatList, ListRenderItem } from "react-native";

type Props = StoreAdminNavigationScreenProps<"TeamScheduleAdminSelectTeam">;

export function TeamScheduleAdminSelectTeam(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <InnerTeamScheduleAdminSelectTeam {...props} fetchKey={fetchKey} />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
function InnerTeamScheduleAdminSelectTeam({
  fetchKey,
  ...props
}: {
  fetchKey: string;
} & Props) {
  const data = useLazyLoadQuery<TeamScheduleAdminSelectTeamQuery>(
    graphql`
      query TeamScheduleAdminSelectTeamQuery {
        store {
          id
          publicTeams {
            id
            name
            ...TeamIconCircleComponent_Team
          }
        }
      }
    `,
    {},
    { fetchKey, fetchPolicy: "store-and-network" }
  );

  const listData = useMemo(
    () => data.store.publicTeams ?? [],
    [data.store.publicTeams]
  );

  const renderItem: ListRenderItem<(typeof listData)[number]> = useCallback(
    ({ item: team, index }) => {
      return (
        <ListItem
          onPress={() => {
            props.navigation.navigateDeprecated("TeamScheduleAdmin", {
              teamId: team.id,
            });
          }}
          left={<TeamIconCircle team={team} size="smallMedium" />}
          right={<ListItem.NavArrow />}
        >
          <ListItem.Title>{team.name}</ListItem.Title>
        </ListItem>
      );
    },
    [props.navigation]
  );

  return (
    <FlatList
      data={listData}
      ItemSeparatorComponent={AHSeparator}
      ListFooterComponent={AHSeparator}
      renderItem={renderItem}
    />
  );
}
